import DSBox from '../../../design-system/DSBox';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import { DSTypography } from '../../../design-system/Typography';
import { useTheme } from '@mui/material';

const CollectionCodeError = () => {
  const { spacing } = useTheme();

  const handleSupportClick = () => {
    window.open('https://www.klydoclock.com/pages/support', '_blank');
  };

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FFFFFF',
        padding: spacing(3),
        textAlign: 'center',
        gap: spacing(4),
      }}
    >
      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: spacing(2),
          maxWidth: '500px',
        }}
      >
        <DSTypography variant="h2" sx={{ color: '#000000' }}>
          Order Not Found
        </DSTypography>

        <DSTypography variant="body1" sx={{ color: '#666666' }}>
          We couldn't find the order you're looking for. Please check your order
          details and try again.
        </DSTypography>

        <DSTypography
          variant="body2"
          sx={{ color: '#999999', marginTop: spacing(1) }}
        >
          If you continue to experience issues, please contact our support team.
        </DSTypography>
      </DSBox>

      <DSPrimaryButton onClick={handleSupportClick}>
        Contact Support
      </DSPrimaryButton>
    </DSBox>
  );
};

export default CollectionCodeError;
